import { assertNever } from "@impero-com/common/utils/obj";

import {
    ElementPosition,
    ElementSpecId,
    GridLocation,
    SectionSpecId,
} from "./types";

type OnAddButton<ElementButtonSpecId extends string> = (
    buttonId: ElementButtonSpecId,
    sectionId: SectionSpecId,
    location: GridLocation
) => void;

export type ButtonsBehaviour<ElementButtonSpecId extends string> =
    | {
          type: "HIDDEN";
      }
    | {
          type: "DRAGGABLE";
          onAddButton: OnAddButton<ElementButtonSpecId>;
      };

export function flattenButtonsBehaviour<ElementButtonSpecId extends string>(
    behaviour: ButtonsBehaviour<ElementButtonSpecId>
): {
    onAddButton: OnAddButton<ElementButtonSpecId> | undefined;
} {
    switch (behaviour.type) {
        case "HIDDEN": {
            return {
                onAddButton: undefined,
            };
        }
        case "DRAGGABLE": {
            return {
                onAddButton: behaviour.onAddButton,
            };
        }
        default: {
            return assertNever(behaviour);
        }
    }
}

type OnMoveElement = (
    sourceElementId: ElementSpecId,
    sourcePosition: ElementPosition,
    targetPosition: ElementPosition
) => void;
type OnMoveSection = (dragIndex: number, insertionIndex: number) => void;

export type ElementsAndSectionsBehaviour =
    | {
          type: "FIXED";
      }
    | {
          type: "DRAGGABLE_ELEMENTS";
          onMoveElement: OnMoveElement;
      }
    | {
          type: "DRAGGABLE_ELEMENTS_AND_SECTIONS";
          onMoveElement: OnMoveElement;
          onMoveSection: OnMoveSection;
      };

export function flattenElementsAndSectionsBehaviour(
    behaviour: ElementsAndSectionsBehaviour
): {
    onMoveElement: OnMoveElement | undefined;
    onMoveSection: OnMoveSection | undefined;
} {
    switch (behaviour.type) {
        case "FIXED": {
            return {
                onMoveElement: undefined,
                onMoveSection: undefined,
            };
        }
        case "DRAGGABLE_ELEMENTS": {
            return {
                onMoveElement: behaviour.onMoveElement,
                onMoveSection: undefined,
            };
        }
        case "DRAGGABLE_ELEMENTS_AND_SECTIONS": {
            return {
                onMoveElement: behaviour.onMoveElement,
                onMoveSection: behaviour.onMoveSection,
            };
        }
        default: {
            return assertNever(behaviour);
        }
    }
}
